/**
 * Created by liuxsen on 2017/6/3.
 */
import hdHead from './hdHead.vue'
export default hdHead



// WEBPACK FOOTER //
// ./src/components/tpl2/hdHead/index.js